import _toastr from 'admin-lte/plugins/toastr/toastr.min';
import $ from 'jquery' // Đảm bảo jQuery đã được cài đặt
export default {
    name: 'Alert',
    success: function ({message, title = "Thông báo", auto_hide = 3000}) {
        _toastr.options.timeOut = auto_hide;
        _toastr.options.extendedTimeOut = auto_hide;
        _toastr.success(message, title)
    },
    warning: function ({message, title = "Thông báo", auto_hide = 3000}) {
        _toastr.options.timeOut = auto_hide;
        _toastr.options.extendedTimeOut = auto_hide;
        _toastr.warning(message, title)
    },
    info: function ({message, title = "Thông báo", auto_hide = 3000}) {
        _toastr.options.timeOut = auto_hide;
        _toastr.options.extendedTimeOut = auto_hide;
        _toastr.info(message, title)
    },
    error: function ({message, title = "Thông báo", auto_hide = 3000}) {
        _toastr.options.timeOut = auto_hide;
        _toastr.options.extendedTimeOut = auto_hide;
        _toastr.error(message, title)
    },

    alertInvalid: function (error) {
        let message = "";
        $.each(error.data, function (index, value) {
            console.log(error.data);
            message += ' - ' + value[0] + '<br>';
        })
        this.warning({message: message, title: "Dữ liệu không hợp lệ."});
    },
}
